var onFocusTrapping = function onFocusTrapping(event, elements) {
  var firstElement = elements[0];
  var lastElement = elements[elements.length - 1];

  if (!event.shiftKey && document.activeElement === lastElement) {
    firstElement.focus();
    return event.preventDefault();
  }

  if (event.shiftKey && document.activeElement === firstElement) {
    lastElement.focus();
    event.preventDefault();
  }
};

export { onFocusTrapping as default };
//# sourceMappingURL=index.js.map
